import { DEAL_STATUS_LABELS, DEAL_STATUS_COLORS } from '@/types/deal';
import type { DealStatus } from '@/types/deal';
import styles from './DealStatusColumn.module.css';

interface DealStatusColumnProps {
  status: DealStatus;
  count: number;
}

export const DealStatusColumn = ({ status, count }: DealStatusColumnProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.statusDot} style={{ background: DEAL_STATUS_COLORS[status] }} />
      <span className={styles.label}>{DEAL_STATUS_LABELS[status]}</span>
      <span className={styles.count}>{count}</span>
    </div>
  );
};
